import { Component } from '@angular/core';
import { Util } from './services/util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'loyalty-sign-up';
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  appTitle: HTMLLinkElement = document.querySelector('#appTitle');
  constructor(private util: Util) {
    this.util.setlocation(location);
    const strBannerId = this.util.getBannerId();

    if (strBannerId === "2") {
      this.favIcon.href = 'assets/images/favicon-lucky.png';
      this.appTitle.innerText = "Lucky Supermarkets";
    }
    else if (strBannerId === "3") {
      this.favIcon.href = 'assets/images/foodmaxx.png';
      this.appTitle.innerText = "Foodmaxx";
    }
    else {
      this.favIcon.href = 'assets/images/favicon-savemart.png';
      this.appTitle.innerText = "Save Mart Supermarkets";
    }
  }
}
